<template>
  <HeroSection title="Contact us" class="bg-slate-800" bg-src="/images/audi-wheel.webp" />

  <section class="container p-10 my-20 text-center border rounded-lg shadow">
    <h2>Contact us</h2>
    <p class="flex flex-wrap justify-center gap-4 my-8">
      <UButton to="mailto:info@driveczech.com" leading-icon="i-heroicons-envelope" aria-label="E-mail">
        info@driveczech.com
      </UButton>
      <UButton to="tel:+420603427002" leading-icon="i-heroicons-phone" aria-label="Telephone">
        +420 603 427 002
      </UButton>
    </p>

    <h2>Or follow and rate us</h2>
    <div class="flex flex-wrap justify-center gap-4 my-8">
      <UButton to="https://www.facebook.com/driveczech" target="_blank" variant="outline" color="black" leading-icon="i-simple-icons-facebook">
        Facebook
      </UButton>
      <UButton to="https://www.instagram.com/driveczech" target="_blank" variant="outline" color="black" leading-icon="i-simple-icons-instagram">
        Instagram
      </UButton>
      <UButton to="https://www.tripadvisor.com/Attraction_Review-g274707-d10898456-Reviews-Driveczech_Your_Personal_Driver-Prague_Bohemia.html" target="_blank" variant="outline" color="black" leading-icon="i-simple-icons-tripadvisor">
        TripAdvisor
      </UButton>
      <UButton to="https://www.youtube.com/@driveczech" target="_blank" variant="outline" color="black" leading-icon="i-simple-icons-youtube">
        Youtube
      </UButton>
      <UButton to="https://www.linkedin.com/company/driveczech" target="_blank" variant="outline" color="black" leading-icon="i-simple-icons-linkedin">
        LinkedIn
      </UButton>
    </div>

    <h2>Company details</h2>
    <div class="mx-auto text-left w-fit">
      driveczech group s.r.o.<br>
      Korunní 2569/108, Vinohrady<br>
      101 00 Praha<br>
      IČO: 17383447<br>
      DIČ: CZ17383447<br>
      Spisová značka: 370951 C,<br>
      Městský soud v Praze
    </div>
  </section>

  <Footer />
</template>
